import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { HeaderLeftIcon } from './headerLeftIcon';
import { Logo } from './logo';

export const Header = () => {
  let match = useRouteMatch('/search');

  return (
    <>
      {match ? null : (
        <header>
          <HeaderLeftIcon />
          <Logo />
        </header>
      )}
    </>
  );
};
